import { Typography, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Checkbox } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings/components/Checkbox';
import { SizeScaling } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings/components/SizeScaling';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';

const t = (key: string, options?) => translate('preferences', key, options);

const ClosedCaptions = ({ handleToggle, handleScaling, closedCaptionsSettings }) => {
  const classes = useStyles();

  const SCALING_VALUES = { '16': 100, '22': 150, '28': 200 };
  const calcPxToPercent = (px) => SCALING_VALUES[px] || 100;

  return (
    <Grid
      item
      xs={12}
      md={12}
      lg={10}
      id="preferencesClosedCaption"
      className={classes.gridSection}
    >
      <Grid container className={classes.grid}>
        <Grid item xs={12} md={5} className={classes.gridContentLeft}>
          <Typography className={classes.title} variant="h5">
            {t('closeCaptions')}
          </Typography>
          <div className={classes.labelText}>
            <Checkbox
              checked={closedCaptionsSettings.showClosedCaptions}
              onChange={handleToggle('closedCaptionsSettings', 'showClosedCaptions')}
              labelText={t('closeCaptionsButtonLabel')}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={`${classes.gridContentRight} ${classes.labelTextScale}`}
        >
          <SizeScaling
            value={calcPxToPercent(closedCaptionsSettings.closedCaptionSize)}
            onChange={handleScaling('closedCaptionsSettings', 'closedCaptionSize')}
            labelText={t('closeCaptionsScaleLabel')}
            statusLabelText={t('closeCaptionsScaleLabel')}
            decreaseAriaLabel={t('decreaseCC')}
            increaseAriaLabel={t('increaseCC')}
            decreaseSizeIcon={faMinus}
            increaseSizeIcon={faPlus}
            stepScaling={6}
            minVal={16}
            maxVal={28}
            rawValue={closedCaptionsSettings.closedCaptionSize}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  grid: {
    paddingBottom: 10,
  },
  title: {
    fontSize: '18px',
    lineHeight: '40px',
  },
  gridSection: {
    margin: 20,
    borderRadius: '5px',
    border: '1px solid lightGray',
  },
  gridContentRight: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  gridContentLeft: {
    margin: `5px 10px`,
  },
  labelText: {
    fontSize: '16px',
    fontFamily: FONT_GSS_FUTURA_BOOK,
    display: 'flex',
    alignItems: 'center',
    '& input': {
      margin: 0,
      width: '20px',
      height: '20px',
    },
    '& input:focus': {
      boxShadow: 'none !important',
    },
    '& span': {
      paddingLeft: 10,
    },
    '& label': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  labelTextScale: {
    fontSize: '16px',
    fontFamily: FONT_GSS_FUTURA_BOOK,
    '& .lwt-common-labeltext': {
      paddingRight: 10,
    },
  },
}));

export default ClosedCaptions;
